import { ProfileResponseDto } from 'src/generated-sources/openapi/configuration-service/profile';

/**
 * Access denial codes returned by the backend in 403 responses
 * from the profile endpoint (`/v1/user/profile`).
 */
export enum ProfileAccessDenialCode {
  /** Access denied due to the lack of an active product on the account. */
  NoProduct = 'DENIED_NO_PRODUCT',
  /** Access denied due to an inactive ETM account. */
  InactiveAccount = 'DENIED_INACTIVE',
}

export type ProfileLoadResult =
  | { status: 'success'; profile: ProfileResponseDto }
  | { status: 'denied'; code: ProfileAccessDenialCode }
  | { status: 'error' };
